import { Component, Input, OnInit } from '@angular/core';
import { FileService } from 'app/_services/file.service';
import { AuthService } from 'app/_services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'signature-upload',
  templateUrl: './signature-upload.component.html',
})
export class SignatureUploadComponent implements OnInit {
  @Input() user: any;

  public showSpinner = false;
  public imageUrl: any;

  constructor(private fileService: FileService, private authService: AuthService) {}

  ngOnInit() {
    if (this.user && this.user.signatureFile) {
      this.getSignature(this.user.signatureFile);
    }
  }

  private getSignature(file) {
    this.fileService.getSignatureImage(file).subscribe((image) => {
      this.imageUrl = image.safeUrl;
    });
  }

  public async onFileChange(event) {
    this.showSpinner = true;
    let files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      files.push(file);
    }

    const body = {
      filesArray: files,
    };

    this.fileService.uploadSignature(this.user.id, body).subscribe(
      () => {
        Swal.fire('Uploaded', 'Signature image has been uploaded.', 'success');

        this.showSpinner = false;
        this.authService.fetchUserAndUpdateIntoGlobals().subscribe((globals: any) => {
          if (globals.user && globals.user.signatureFile) {
            this.getSignature(globals.user.signatureFile);
          }
        }, (error) => {
          if (this.authService.isInvalidRoleCombinationError(error)) {
            this.authService.redirectToInvalidRoleCombinationError(error);
            return;
          }
          throw error;
        });
      },
      (error: any) => {
        Swal.fire('Error', 'Could not upload file.', 'error');

        this.showSpinner = false;
        throw error;
      }
    );
  }
}
